import { render, staticRenderFns } from "./_base-tooltip.vue?vue&type=template&id=6105ba3a&scoped=true&"
import script from "./_base-tooltip.vue?vue&type=script&lang=ts&"
export * from "./_base-tooltip.vue?vue&type=script&lang=ts&"
import style0 from "./_base-tooltip.vue?vue&type=style&index=0&id=6105ba3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105ba3a",
  null
  
)

export default component.exports